<template>
  <div class="">
    <div class="dropdown">

      <template v-if="isAuthenticated">
        <button @click="myFunction()" class="menu-4-dropdown btn btn-sm rounded-pill btn-primary">
          {{ profileName }}
        </button>
        <div id="menu-4" class="dropdown-content">
          <slot></slot>
        </div>
      </template>

      <div class="" v-else>
        <m-modal1 modal-size="modal-xl" :modal-button-text="profileName">
          <m-login1 :image="image" :show-panels="showPanels" :redirect="redirect">
            <template #classic-login-p-1-top>
              <slot name="classic-login-p-1-top"/>
            </template>
            <template #classic-login-p-1-bottom>
              <slot name="classic-login-p-1-bottom"/>
            </template>
            <template #two-step-login-p-1-top>
              <slot name="two-step-login-p-1-top"/>
            </template>
            <template #two-step-login-p-1-bottom>
              <slot name="two-step-login-p-1-bottom"/>
            </template>
          </m-login1>
        </m-modal1>
      </div>


    </div>
  </div>
</template>


<script>
import {defineComponent} from 'vue'
import {mapGetters} from "vuex";
import mA from '../Tags/A.vue'
import mModal1 from '../Tool/Modal/Modal1.vue'
import mLogin1 from "../Authentication/Login/Login1.vue";
import {loginProps} from "../Authentication/Login/LoginProps";

export default defineComponent({
  name: "Menu4",
  props: {
    ...loginProps
  },
  components: {mA, mModal1, mLogin1},
  computed: {
    ...mapGetters({
      isAuthenticated: 'User/isAuthenticated',
      profile: 'User/getProfile'
    }),
    profileName() {
      if (this.isAuthenticated) {
        return `${this.profile.name} ${this.profile.last_name}`
      }
      return this.$t('menu.un_authenticated_profile_text')
    }
  },
  methods: {
    myFunction() {
      document.getElementById("menu-4").classList.toggle("show");
    },
  },
  mounted() {

    window.onclick = function (event) {
      if (!event.target.matches('.menu-4-dropdown')) {
        var dropdowns = document.getElementsByClassName("dropdown-content");
        var i;
        for (i = 0; i < dropdowns.length; i++) {
          var openDropdown = dropdowns[i];
          if (openDropdown.classList.contains('show')) {
            openDropdown.classList.remove('show');
          }
        }
      }
    }


  }
})
</script>


<style scoped>
.dropdown {
  position: relative;
  display: inline-block;
}

.dropdown-content {
  display: none;
  position: absolute;
  background-color: #f1f1f1;
  min-width: 160px;
  overflow: auto;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 1;
}

.dropdown-content a {
  color: black;
  padding: 12px 16px;
  text-decoration: none;
  display: block;
}

.dropdown a:hover {
  background-color: var(--secondary);
}

.show {
  display: block;
}
</style>